import { useSelector } from "react-redux";
import { useContext } from "react";
import _ from "lodash";

import { useIntegrationWhatsApp } from "../../../../hooks/useIntegrationWhatsApp";
import { GlobalContext } from "../../../../context/GlobalContext";
import { OrderContext } from "../../../../context/OrderContext";
import { sendPrint } from "../../../../reporting/print";
import { maskCurrency } from "../../../../utils/utils";
import { api } from "../../../../api/api";
import { CardIfood } from "../CardIfood";
import { Card } from "../Card";

export function ListaPedidos({ setOrderIfood, dataProductsNotSeen }) {
  const { toggleOffCanvas } = useContext(GlobalContext);
  const { sendMessage } = useIntegrationWhatsApp();
  const { updated, orders, selectOrder } = useContext(OrderContext);
  const dataOrdersIfood = useSelector((state) => state?.ifoodOrders?.orders);

  function getQuantityOrdersWithStatus(status) {
    return (
      orders?.filter(
        (value) => value.typeOrder === "delivery" && value.status === status
      )?.length ?? 0
    );
  }

  return (
    <>
      <div className="card-pai-order">
        <section className="card card-order order-column-open">
          <div className="order-column-header">
            <div>
              Em aberto
            </div>
            <div className="order-column-count">
              {getQuantityOrdersWithStatus("aguardando") ?? 0}
            </div>
          </div>
          <div className="card-body order-column-body">
            {_.orderBy(orders, (a) => a.numOrder, "desc")
              .filter(
                (order) =>
                  order.status === "aguardando" &&
                  ["frente-de-caixa", "delivery"].includes(
                    order.typeOrder
                  )
              )
              .map((order) => {
                return (
                  <Card
                    id={order.id}
                    order={order}
                    numOrder={order?.numOrder}
                    methodDelivery={order.methodDelivery}
                    key={order.id}
                    name={order.name}
                    pricing={maskCurrency(order.total)}
                    createdAt={order.createdAt}
                    paymentMethod={order.paymentMethod}
                    isUpdated={
                      (dataProductsNotSeen?.groupNumOrder[
                        order.numOrder
                      ]?.length ?? 0) > 0
                    }
                    next={async () => {
                      await updated(
                        order.id,
                        "status",
                        "aprovado",
                        false
                      );

                      if (order.typeOrder === "delivery") {
                        await sendMessage(
                          order.phone,
                          "messageAccepted",
                          order
                        );
                      }
                    }}
                    selectOrder={() => {
                      selectOrder(order.id)
                      toggleOffCanvas()
                    }}
                    print={async () =>
                      await sendPrint("order", {}, order.id)
                    }
                    address={`${order.address}, ${order.number}, ${order.complement}`}
                    status={order.status}
                    refused={async () => {
                      await selectOrder(order.id);
                      new window.bootstrap.Modal(
                        document.getElementById(
                          "modalRefusedOrder"
                        ),
                        {}
                      ).toggle();
                    }}
                  />
                );
              })}

            {_.orderBy(dataOrdersIfood, (a) => a.createdAt, "asc")
              .filter((o) => o.status === "aguardando")
              .map((e) => {
                const pedido = e.payload[0];
                return (
                  <>
                    <CardIfood
                      id={e.id}
                      key={e.id}
                      numOrder={pedido.displayId}
                      name={pedido.customer.name}
                      pricing={maskCurrency(
                        pedido.total.orderAmount
                      )}
                      createdAt={e.createdAt}
                      address={`${pedido?.delivery?.deliveryAddress?.formattedAddress}`}
                      status={e.status}
                      selectOrder={() => setOrderIfood(e)}
                      next={async () =>
                        await api.get(
                          "/ifood/confirm/" + pedido.id
                        )
                      }
                      orderType={pedido?.orderType}
                      order={e}
                    />
                  </>
                );
              })}

            {orders?.filter(
              (order) =>
                order.status === "aguardando" &&
                ["frente-de-caixa", "delivery"].includes(
                  order.typeOrder
                )
            ).length === 0 && dataOrdersIfood.length === 0 && (
                <div className="order-empty-state">
                  <span>✓</span>
                  <p>Sem pedidos por aqui</p>
                </div>
              )}
          </div>
        </section>
        <section className="card card-order order-column-preparing">
          <div className="order-column-header">
            <div>
              Em preparo
            </div>
            <div className="order-column-count">
              {getQuantityOrdersWithStatus("aprovado")}
            </div>
          </div>
          <div className="card-body order-column-body">
            {_.orderBy(orders, (a) => a.numOrder, "desc")
              .filter(
                (order) =>
                  order.status === "aprovado" &&
                  ["frente-de-caixa", "delivery"].includes(
                    order.typeOrder
                  )
              )
              .map((order) => {
                return (
                  <Card
                    id={order.id}
                    order={order}
                    paymentMethod={order.paymentMethod}
                    numOrder={order?.numOrder}
                    methodDelivery={order.methodDelivery}
                    key={order.id}
                    name={order.name}
                    pricing={maskCurrency(order.total)}
                    createdAt={order.createdAt}
                    isUpdated={
                      (dataProductsNotSeen?.groupNumOrder[
                        order.numOrder
                      ]?.length ?? 0) > 0
                    }
                    next={async () => {
                      await updated(
                        order.id,
                        "status",
                        "em_entrega",
                        false
                      );
                      if (order.typeOrder === "delivery" && order.methodDelivery === 'entrega') {
                        await sendMessage(
                          order.phone,
                          "messageSendDelivery",
                          order
                        );
                      }

                      if (order.typeOrder === "delivery" && order.methodDelivery === 'retirada') {
                        await sendMessage(
                          order.phone,
                          "messageAvailableWithdrawal",
                          order
                        );
                      }
                    }}
                    selectOrder={() => {
                      selectOrder(order.id)
                      toggleOffCanvas()
                    }}
                    print={async () =>
                      await sendPrint("order", {}, order.id)
                    }
                    status={order.status}
                    address={`${order.address}, ${order.number}, ${order.complement}`}
                    responseWebmania={
                      order?.statusNota === "Emitida"
                        ? order.response
                        : null
                    }
                  />
                );
              })}

            {_.orderBy(dataOrdersIfood, (a) => a.createdAt, "asc")
              .filter((o) => o.status === "aprovado")
              .map((e) => {
                const pedido = e.payload[0];
                return (
                  <>
                    <CardIfood
                      id={e.id}
                      key={e.id}
                      numOrder={pedido?.displayId}
                      name={pedido?.customer?.name}
                      pricing={maskCurrency(
                        pedido?.total?.orderAmount
                      )}
                      createdAt={e.createdAt}
                      address={`${pedido?.delivery?.deliveryAddress?.formattedAddress}`}
                      status={e.status}
                      selectOrder={() => setOrderIfood(e)}
                      next={async () =>
                        await api.get(
                          "/ifood/dispach/" + pedido?.id
                        )
                      }
                      orderType={pedido?.orderType}
                      order={e}
                    />
                  </>
                );
              })}

            {orders?.filter(
              (order) =>
                order.status === "aprovado" &&
                ["frente-de-caixa", "delivery"].includes(
                  order.typeOrder
                )
            ).length === 0 && dataOrdersIfood.length === 0 && (
                <div className="order-empty-state">
                  <span>✓</span>
                  <p>Sem pedidos por aqui</p>
                </div>
              )}
          </div>
        </section>
        <section className="card card-order order-column-delivery">
          <div className="order-column-header">
            <div>
              Em entrega
            </div>
            <div className="order-column-count">
              {getQuantityOrdersWithStatus("em_entrega")}
            </div>
          </div>
          <div className="card-body order-column-body">
            {_.orderBy(orders, (a) => a.numOrder, "desc")
              .filter(
                (order) =>
                  ["em_entrega", "pronto_para_retirada"].includes(
                    order.status
                  ) &&
                  ["frente-de-caixa", "delivery"].includes(
                    order.typeOrder
                  )
              )
              .map((order) => {
                return (
                  <Card
                    id={order.id}
                    order={order}
                    numOrder={order?.numOrder}
                    paymentMethod={order.paymentMethod}
                    methodDelivery={order.methodDelivery}
                    key={order.id}
                    name={order.name}
                    pricing={maskCurrency(order.total)}
                    createdAt={order.createdAt}
                    isUpdated={
                      (dataProductsNotSeen?.groupNumOrder[
                        order.numOrder
                      ]?.length ?? 0) > 0
                    }
                    next={async () => {
                      await updated(
                        order.id,
                        "status",
                        "finalizado",
                        false
                      );
                      if (order.typeOrder === "delivery") {
                        await sendMessage(
                          order.phone,
                          "messageSendReview",
                          order
                        );
                      }
                    }}
                    selectOrder={() => {
                      selectOrder(order.id)
                      toggleOffCanvas()
                    }}
                    print={async () =>
                      await sendPrint("order", {}, order.id)
                    }
                    status={order.status}
                    address={`${order.address}, ${order.number}, ${order.complement}`}
                    responseWebmania={
                      order?.statusNota === "Emitida"
                        ? order.response
                        : null
                    }
                  />
                );
              })}

            {_.orderBy(dataOrdersIfood, (a) => a.createdAt, "asc")
              .filter((o) =>
                ["em_entrega", "pronto_para_retirada"].includes(
                  o.status
                )
              )
              .map((e) => {
                const pedido = e.payload[0];
                return (
                  <>
                    <CardIfood
                      id={e.id}
                      key={e.id}
                      numOrder={pedido.displayId}
                      name={pedido.customer.name}
                      pricing={maskCurrency(
                        pedido.total.orderAmount
                      )}
                      createdAt={e.createdAt}
                      address={`${pedido?.delivery?.deliveryAddress?.formattedAddress}`}
                      status={e.status}
                      selectOrder={() => setOrderIfood(e)}
                      orderType={pedido?.orderType}
                      order={e}
                      next={async () =>
                        await api.get(
                          "/ifood/finished/" + pedido.id
                        )
                      }
                    />
                  </>
                );
              })}
            {orders?.filter(
              (order) =>
                order.status === "em_entrega" &&
                ["frente-de-caixa", "delivery"].includes(
                  order.typeOrder
                )
            ).length === 0 && dataOrdersIfood.length === 0 && (
                <div className="order-empty-state">
                  <span>✓</span>
                  <p>Sem pedidos por aqui</p>
                </div>
              )}
          </div>
        </section>
        <section className="card card-order order-column-finished">
          <div className="order-column-header">
            <div>
              Finalizado
            </div>
            <div className="order-column-count">
              {getQuantityOrdersWithStatus("finalizado")}
            </div>
          </div>
          <div className="card-body order-column-body">
            {_.orderBy(orders, (a) => a.numOrder, "desc")
              .filter(
                (order) =>
                  [
                    "finalizado",
                    "cancelado",
                    "recusado",
                  ].includes(order.status) &&
                  ["frente-de-caixa", "delivery"].includes(
                    order.typeOrder
                  )
              )
              .sort((a, b) => a.status - b.status)
              .map((order) => {
                return (
                  <Card
                    id={order.id}
                    order={order}
                    paymentMethod={order.paymentMethod}
                    numOrder={order?.numOrder}
                    methodDelivery={order.methodDelivery}
                    key={order.id}
                    name={order.name}
                    pricing={maskCurrency(order.total)}
                    createdAt={order.createdAt}
                    next={null}
                    selectOrder={() => {
                      selectOrder(order.id)
                      toggleOffCanvas()
                    }}
                    print={async () =>
                      await sendPrint("order", {}, order.id)
                    }
                    address={`${order.address}, ${order.number}, ${order.complement}`}
                    status={order.status}
                  />
                );
              })}

            {_.orderBy(dataOrdersIfood, (a) => a.createdAt, "asc")
              .filter((o) =>
                ["finalizado", "cancelado", "recusado"].includes(
                  o.status
                )
              )
              .map((e) => {
                const pedido = e.payload[0];
                return (
                  <>
                    <CardIfood
                      id={e.id}
                      key={e.id}
                      numOrder={pedido.displayId}
                      name={pedido.customer.name}
                      pricing={maskCurrency(
                        pedido.total.orderAmount
                      )}
                      createdAt={e.createdAt}
                      address={`${pedido?.delivery?.deliveryAddress?.formattedAddress}`}
                      status={e.status}
                      selectOrder={() => setOrderIfood(e)}
                      orderType={pedido?.orderType}
                      order={e}
                    />
                  </>
                );
              })}

            {orders?.filter(
              (order) =>
                ["finalizado", "cancelado", "recusado"].includes(
                  order.status
                ) &&
                ["frente-de-caixa", "delivery"].includes(
                  order.typeOrder
                )
            ).length === 0 && dataOrdersIfood.length === 0 && (
                <div className="order-empty-state">
                  <span>✓</span>
                  <p>Sem pedidos por aqui</p>
                </div>
              )}
          </div>
        </section>
      </div>
    </>
  )
}
